<template>
  <el-card
    :body-style="{ padding: '0px' }"
    shadow="never"
    class="card-box cursor-pointer"
  >
    <div
      class="position-relative"
      :class="{
        'opacity-05': (type == 'register' && status == 2) || statusCourse == 0,
      }"
    >
      <!-- <div v-if="type == 'studying'" class="progress-box">
        <div class="position-relative flex-display ai-center js-center">
          <div v-if="pass == false" class="position-absolute">
            <p class="text-font-14 color-danger-lighter mg-less">ไม่ผ่าน</p>
          </div>

          <div v-else class="position-absolute">
            <p class="text-font-10 mg-less">เรียนได้</p>
            <p
              class="text-font-18 mg-less"
              :class="{ 'color-warning': progress > 0 }"
            >
              {{ progress.toFixed(0) }}<span class="text-font-10">%</span>
            </p>
          </div>

          <el-progress
            type="circle"
            :percentage="pass == false ? 100 : progress"
            :width="70"
            :color="pass == false ? '#ff7878' : '#FFB800'"
            :show-text="false"
          ></el-progress>
        </div>
      </div>
      <div v-if="type == 'studying' && pass == false" class="pass-box">
        <el-button
          @click="saveStatusCourse"
          type="primary"
          size="small"
          class="light width-100"
          >เรียนใหม่</el-button
        >
      </div> -->
      <div v-if="type == 'register'" class="status-box">
        <el-button
          :type="status == 2 ? 'danger' : status == 1 ? 'success' : 'warning'"
          :class="{ light: status == 2 || status == 1 }"
          size="small"
          >{{
            status == 2 ? "ไม่อนุมัติ" : status == 1 ? "อนุมัติ" : "รออนุมัติ"
          }}</el-button
        >
      </div>
      <div v-if="type == 'graduate'" class="status-box">
        <el-button type="success" class="light" size="small"
          >จบเมื่อ {{ dateEnd | dateThNumber }}</el-button
        >
      </div>
      <div
        @click="goToLearning"
        class="image-course"
        :style="`background-image:url(` + urlImage + `);`"
      ></div>

      <div @click="goToLearning" class="pd-3 text-left">
        <el-tooltip
          class="item"
          effect="dark"
          :content="name"
          placement="bottom-start"
        >
          <h4 class="mg-less text-title">{{ name }}</h4>
        </el-tooltip>
        <div class="bottom clearfix pd-t-5">
          <span
            v-if="typeCourse !== 'link' && totaltimeCourse"
            class="text-font-14 color-gray"
            >เวลาเรียน {{ totaltimeCourse }} ชั่วโมง</span
          >
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    name: {
      type: String,
      default() {
        return "";
      },
    },
    image: {
      type: String,
      default() {
        return "";
      },
    },
    type: {
      type: String,
      default() {
        return "";
      },
    },
    pass: {
      type: Boolean,
      default() {
        return true;
      },
    },
    progress: {
      type: Number,
      default() {
        return 100;
      },
    },
    status: {
      type: Number,
      default() {
        return 0;
      },
    },
    dateEnd: {
      type: String,
      default() {
        return "";
      },
    },
    showReview: {
      type: Boolean,
      default() {
        return false;
      },
    },
    studyId: {
      type: String,
      default() {
        return "";
      },
    },
    statusCourse: {
      type: Number,
      default() {
        return 1;
      },
    },
    typeCourse: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    urlImage() {
      if (this.typeCourse === "link") {
        return `${this.urlCouse}${this.image}`;
      } else if (this.image != "") {
        return `${this.urlCouse}${this.id}/${this.image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    totaltimeCourse() {
      let time = 0;
      this.courseSubjects.map((item) => {
        let hours =
          item.totalStudyTime && item.totalStudyTime.hours
            ? item.totalStudyTime.hours
            : 0;
        let minute =
          item.totalStudyTime && item.totalStudyTime.minute
            ? item.totalStudyTime.minute
            : 0;

        time = time + hours * 60 + minute;
      });

      return `${parseInt(time / 60)}.${time - parseInt(time / 60) * 60}`;
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,

      courseSubjects: [],
    };
  },
  mounted() {
    this.fetchDetailCourse();
  },
  methods: {
    goToLearning() {
      if (this.typeCourse === "link") {
        window.open("https://www.live-platforms.com/news-activities/47");
      } else if (this.statusCourse == 0) {
        return null;
      } else {
        this.$router.push(`/course/detail?courseId=${this.id}`);
      }
    },
    saveStatusCourse() {
      this.$emit("saveStatusCourse", this.studyId);
    },
    fetchDetailCourse() {
      let obj = {
        _id: this.id,
      };

      HTTP.post(`detail/course`, obj).then((res) => {
        if (res.data.success) {
          this.courseSubjects = res.data.obj.subjects;
        }
      });
    },
  },
};
</script>

<style scoped>
.image-course {
  height: 245px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.progress-box {
  position: absolute;
  width: 100px;
  height: 80px;
  background: #ffffff;
  opacity: 0.95;
  border-radius: 0px 0px 5px 5px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pass-box {
  position: absolute;
  width: 118px;
  right: -2px;
  top: 90px;
}
.status-box {
  position: absolute;
  right: 15px;
  top: -2px;
}
</style>
